import nicolePic from "@/public/images/artists/nicole.png";
import { Artist } from "@/types/types";

export const nicole = {
  id: "113",
  name: "Nicole",
  image: nicolePic,
  description: `Nicole's mezzo-soprano voice is defined by its agility, precision, and clarity in execution. Her vocal timbre combines power and finesse, exemplifying contemporary vocal stylings prevalent in pop music.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnicole-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Pop", "RnB", "Unprocessed", "Airy", "Falsetto"],
      secondary: ["Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 51,
        high: 84,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
